import { Outlet, Navigate } from "react-router-dom";
import NavBar from "./NavBar";
import TabBar from "./TabBar";
import { useAuth } from "@/contexts/AuthContext";

export default function Layout() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <NavBar />
      <main className="flex-1 overflow-y-auto pt-14 pb-20 max-w-[375px] mx-auto w-full">
        <Outlet />
      </main>
      <TabBar />
    </div>
  );
}